<div>
  <p class="p1">
    {{ 'Newsletters:' | trans:'customers/customer-details-modal/newsletter/newsletter.Label' }}
  </p>

  <table class="base full-width m-t-16">
    <thead>
    <tr>
      <th>
        {{ 'Newsletter' | trans:'customers/customer-details-modal/newsletter/newsletter/newsletter.Label' }}
      </th>
      <th>
        {{ 'Status' | trans:'customers/customer-details-modal/newsletter/newsletter/status.Label' }}
      </th>
      <th></th>
    </tr>
    </thead>
    <tbody>
      @for (s of customer.subscriptions; track s.subscriberId) {
        <tr>
          <td>
            <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
              {{ s.cinema }}
            </div>
          </td>
          <td>
            <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
              <div class="tag tag--{{ s.status }}">
                {{ s.status | trans:'customers/customer-details-modal/newsletter/newsletter/status.' + s.status }}
              </div>
            </div>
          </td>
          <td>
            <div class="d-flex align-items-center justify-content-flex-end">
              <app-switch
                [(ngModel)]="s.isActive"
                (ngModelChange)="toggleSubscription(s)"
              />
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
